import type { Feature } from './types';
import type { AdTextProviders } from 'types/client/adProviders';

const title = 'Text ads';

const config: Feature<{ provider: AdTextProviders }> = Object.freeze({
  title,
  isEnabled: false,
});

export default config;
